import React from 'react';
import { logout } from '../../../firebase/authService';
import { hasFirebaseConfig } from '../../../firebase/firebaseConfig';
import styles from './SignOut.module.css';

export default function SignOut() {
  const ready = hasFirebaseConfig();
  const onSignOut = async () => {
    try {
      await logout();
      alert('サインアウト完了');
    } catch (err) {
      alert('サインアウト失敗: ' + (err.message || ''));
    }
  };

  if (!ready) {
    return (
      <div className={styles.container}>
        <h1 className={styles.title}>サインアウト</h1>
        <p className={styles.text}>Firebase 設定がないためサインアウト機能は無効です。</p>
      </div>
    );
  }

  return (
      <div className={styles.container}>
        <h1 className={styles.title}>サインアウト</h1>
        <p className={styles.text}>現在ログイン中のセッションを終了しますか？</p>
        <button className={styles.button} onClick={onSignOut}>サインアウトする</button>
      </div>
  );
}
